import { render, staticRenderFns } from "./ServicepointsPage.vue?vue&type=template&id=3e610148&scoped=true"
import script from "./ServicepointsPage.vue?vue&type=script&lang=ts"
export * from "./ServicepointsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e610148",
  null
  
)

export default component.exports